const SaudiArabiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112284)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#6DA544"
      />
      <path
        d="M11.3042 23.9131C11.3042 25.3538 12.4722 26.5218 13.9129 26.5218H21.739C21.739 27.7224 22.7122 28.6957 23.9129 28.6957H26.5215C27.7222 28.6957 28.6954 27.7224 28.6954 26.5218V23.9131H11.3042Z"
        fill="#F0F0F0"
      />
      <path
        d="M28.9135 11.3047V17.3916C28.9135 18.3506 28.1333 19.1308 27.1743 19.1308V21.7395C29.5717 21.7395 31.5221 19.789 31.5221 17.3916V11.3047H28.9135Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.2177 17.3916C10.2177 18.3506 9.4375 19.1308 8.47852 19.1308V21.7395C10.8759 21.7395 12.8263 19.789 12.8263 17.3916V11.3047H10.2177V17.3916Z"
        fill="#F0F0F0"
      />
      <path d="M25 11.3047H27.6087V17.3916H25V11.3047Z" fill="#F0F0F0" />
      <path
        d="M21.0873 14.783C21.0873 15.0227 20.8923 15.2177 20.6526 15.2177C20.4129 15.2177 20.2178 15.0227 20.2178 14.783V11.3047H17.6091V14.783C17.6091 15.0227 17.4141 15.2177 17.1744 15.2177C16.9347 15.2177 16.7396 15.0227 16.7396 14.783V11.3047H14.1309V14.783C14.1309 16.4612 15.4962 17.8265 17.1744 17.8265C17.8207 17.8265 18.4201 17.6234 18.9135 17.2784C19.4069 17.6233 20.0063 17.8265 20.6527 17.8265C20.7828 17.8265 20.9108 17.8173 21.0366 17.8013C20.8518 18.563 20.1659 19.1308 19.3483 19.1308V21.7395C21.7457 21.7395 23.6961 19.789 23.6961 17.3916V14.783V11.3047H21.0874V14.783H21.0873Z"
        fill="#F0F0F0"
      />
      <path d="M14.1309 19.1299H18.0439V21.7386H14.1309V19.1299Z" fill="#F0F0F0" />
    </g>
    <defs>
      <clipPath id="clip0_4152_112284">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SaudiArabiaSvg;
